<template>
    <div>
        <!-- Header -->
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-8 d-flex align-items-center">

                        <h5 class="m-0 p-0 align-self-center">
                            <a :href="'/teacher/courses'">
                                <i class="fas fa-tv mr-1"></i> Cursos
                            </a>
                        </h5>

                        <!--

                            <h5 class="m-0 p-0 ml-2 align-self-center">
                                / {{ course.name }}
                            </h5>
                        -->

                    </div>
                    <div class="col-12 col-sm-4 d-flex justify-content-end">
<!--                        <div class="font-weight-bold-500 text-muted">-->
<!--                            {{ course.modules_duration_human }} de duração total do curso-->
<!--                        </div>-->

                        <b-button variant="outline-primary" size="sm" @click="load" class="ml-2" title="Atualizar Conteúdo">
                            <i class="fas fa-sync-alt"></i>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Container -->
        <div class="container mb-4 mt-3">

            <b-overlay :show="loading" rounded="sm">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <div class="fs-5 text-dark fw-bolder py-2 border-bottom">{{ course.name }}</div>
                        <div class="text-black-50 fs-6 fw-medium my-2" v-if="course.description">
                            {{ course.description }}
                        </div>
                    </div>
                    <div class="col-12 col-md-8">

                        <div v-if="modules.length === 0" class="bg-light rounded border p-3 text-left">
                            Você ainda não tem módulos neste curso. Crie agora e começe a ensinar!
                        </div>

                        <div class="accordion" v-for="module in modules" :key="module.id" role="tablist">
                            <module-item
                                :module="module"
                                @updated="load"
                                @destroyed="load"
                                @orderUp="orderUp"
                                @orderDown="orderDown">
                            </module-item>
                        </div>

                        <div class="mt-3">
                            <b-button variant="outline-primary" @click="openModalCreateModule">
                                <i class="fas fa-plus mr-1"></i> Novo Módulo
                            </b-button>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>

        <!-- Modal Create Module -->
        <create-module :course="course" @created="load"></create-module>

        <!-- Modal Lesson Preview -->
        <lesson-preview></lesson-preview>
    </div>
</template>

<script>
import CreateModule from "./Create";
import ModuleItem from "./ModuleItem";
import LessonPreview from "./LessonPreview";

export default {
    props: ['course'],
    components: {
        CreateModule,
        ModuleItem,
        LessonPreview
    },
    data() {
        return {
            loading: false,
            modules: [],
        }
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            axios.get('/teacher/courses/' + this.course.id + '/modules/all')
                .then(response => {
                    this.modules = response.data.data.modules;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });
        },

        openModalCreateModule() {
            this.$root.$emit('open-modal-create-module', this.course);
        },

        orderUp(id) {
            this.loading = true;
            axios.put('/teacher/courses/' + this.course.id + '/modules/' + id + '/order', {
                orderDirection: 'up'
            })
                .then(response => {
                    this.load();
                })
                .catch(error => {
                    this.loading = false;
                });
        },

        orderDown(id) {
            this.loading = true;
            axios.put('/teacher/courses/' + this.course.id + '/modules/' + id + '/order', {
                orderDirection: 'down'
            })
                .then(response => {
                    this.load();
                })
                .catch(error => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped>

</style>
